import {useUserStore} from '@/stores'
import {useRepository} from '@/composables'
import {transform, participant, toWsMessage} from '@/messages'
import {useEventBus} from '@vueuse/core'

export const useProfileCallback = () => {
  const user = useUserStore()
  let profileSent = false

  useEventBus('strategy:ready').on(() => {
    if (!user.isClient || profileSent) return
    const {sendWsEvent} = useRepository()
    const {os, device, browser, cpu, engine} = user.deviceInfo
    sendWsEvent(
      participant.profileMessage({
        os: {...os},
        device: {...device},
        browser: {...browser},
        cpu: {...cpu},
        engine: {...engine},
      })
    )
    profileSent = true
  })

}
